export const IDLE_MS = 30 * 60 * 1000;
export function sessionKeys(uid) {
  const prefix = `wws:session:${uid}:`;
  return {activity: `${prefix}activity`, locked: `${prefix}locked`, unlock: `${prefix}unlock`};
}
export function activityTime(value, now) {
  const time = Number(value);
  return Number.isFinite(time) && time > 0 && time <= now ? time : null;
}
export function idleExpired(last, now, timeoutMs = IDLE_MS) {return now - last >= timeoutMs;}

// Call only after successful credential verification, never on page restore or
// automatic token refresh. Storage failure must not turn a successful login into
// an error; the current tab is notified separately.
export function resumeAuthenticatedSession(uid, storage, now = Date.now()) {
  const keys = sessionKeys(uid);
  try {
    storage.setItem(keys.activity, String(now));
    storage.setItem(keys.locked, "0");
    storage.setItem(keys.unlock, String(now));
  } catch { /* Per-tab unlock still works without browser storage. */ }
  return now;
}
export async function authenticateSession(signIn, storage, notify, clock = Date.now) {
  const result = await signIn();
  if (result?.user?.uid) {
    const at = resumeAuthenticatedSession(result.user.uid, storage, clock());
    notify({uid: result.user.uid, at});
  }
  return result;
}
